import { log } from '@shared/utils/log';
export const trackEvent = (parameters: {
  eventCategory?: string;
  eventLabel?: string;
  eventName: string;
  eventValue?: number;
}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: parameters.eventName,
      event_category: parameters.eventCategory,
      event_label: parameters.eventLabel,
      value: parameters.eventValue,
    });
  } catch (error) {
    log.error('Error tracking event:', error);
  }
};

export const trackPageView = (path: string, title?: string) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: path,
      page_title: title,
    });
  } catch (error) {
    log.error('Error tracking page view:', error);
  }
};
